import { AreaContainer } from '../../containers/filters/AreaContainer';
import { EFilterType, IDefaultFilter } from '../../types/filters';

export const area: IDefaultFilter = {
  component: AreaContainer,
  type: EFilterType.Default,
};
